var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.appClasses,
    attrs: {
      "id": "app"
    }
  }, [_vm.error ? _c('ErrorPage', _vm._b({}, 'ErrorPage', {
    error: _vm.error
  }, false)) : _c('Router', _vm._b({}, 'Router', {
    height: _vm.height,
    width: _vm.width,
    isMobile: _vm.isMobile
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }